import chroma from 'chroma-js';

// hex transitions suck, alpha would need svg fill #rrggbb and fill-opacity #a
export const color2css = (color) => chroma(color).hex();

export const fixLineHeight = (obj: any) => {
  if (typeof obj === 'number') return obj;
  return 1.25;
};

export type DashType = 'solid' | 'dotted' | 'dashed' | 'double-dashed';

export const strokeDasharrayFormat = (_value: string): string => {
  switch (_value) {
    case 'solid':
      return 'none';
    case 'dotted':
      return '1px, 4px';
    case 'dashed':
      return '3, 2';
    case 'double-dashed':
      return '8px, 12px';
    default:
      return 'none';
  }
};

export const tailWindEqual = {
  'justify-center' :'center',
  'justify-start' :'flex-start',
  'justify-end':'flex-end',
  'items-center' :'center',
  'items-start' :'flex-start',
  'items-end':'flex-end'
}

/**
   * Returns a string : svg path of the arrow
   * @param size number, defines the gurth of the arrow
   * @param length number, defines the length of the arrow
   * @returns svg path string
   */
export const createArrow = (size: number, length: number): string => {
  const depth = 0.55
  const fX = Math.cos(Math.PI / 4) * size
  const fY = Math.sin(Math.PI / 4) * size

  let path = `M0,${-size/2}`

  // path += `L${length * depth},${-size/2}`
  path += `L${length/2 + fY},${-size/2}`
  path += `L${length/2 - fX},${-length/2 + fY}` // Flap
  path += `L${length/2},${-length/2}`
  path += `L${length},${0}`
  path += `L${length/2},${length/2}`
  path += `L${length/2 - fX},${length/2 - fY}` // Flap
  // path += `L${length * depth},${size/2}`
  path += `L${length/2 + fY},${size/2}`
  path += `L0,${size/2}`
  path += `Z`

  return path;
}
